// utils/loadAdSenseOnce.js
export function loadAdSenseOnce(clientId) {
    if (typeof window === "undefined") return;
    const src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientId)}`;
    const exists = Array.from(document.scripts).some(s => s.src === src);
    if (exists) return;

    const s = document.createElement("script");
    s.async = true;
    s.src = src;
    s.crossOrigin = "anonymous";
    document.head.appendChild(s);
}
